/*@ngInject*/
const TaskDetailsDrawerDirective = function ($timeout, $document, coreMediator, landingConstant, dateUtil) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let timerDelay = 300,
            timeoutList = [];

        $scope.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
        $scope.itemModel.drawerOpen = false;

        $scope.assignedToImage = null;
        $scope.assignedByImage = null;
        $scope.resolvedByImage = null;

        $scope.assignedToImageLoading = false;
        $scope.assignedByImageLoading = false;
        $scope.resolvedByImageLoading = false;

        function loadAssignedToImage() {
            if (!$scope.itemModel.assignedToId) {
                return;
            }
            $scope.assignedToImageLoading = true;
            coreMediator.loadProfileImage($scope.itemModel.assignedToId).then(function (assignedToImage) {
                $scope.assignedToImage = assignedToImage;
                $scope.assignedToImageLoading = false;
            });
        }

        function loadAssignedByImage() {
            if (!$scope.itemModel.assignedById) {
                return;
            }
            $scope.assignedByImageLoading = true;
            coreMediator.loadProfileImage($scope.itemModel.assignedById).then(function (assignedByImage) {
                $scope.assignedByImage = assignedByImage;
                $scope.assignedByImageLoading = false;
            });
        }

        function loadResolvedByImage() {
            if (!$scope.itemModel.resolvedById) {
                return;
            }
            $scope.resolvedByImageLoading = true;
            coreMediator.loadProfileImage($scope.itemModel.resolvedById).then(function (resolvedByImage) {
                $scope.resolvedByImage = resolvedByImage;
                $scope.resolvedByImageLoading = false;
            });
        }

        function scrollDrawerIntoView() {
            let $scrollContainer = $elm.parents('.scrollVerticalContainer');

            let scrollContainerHeight = $scrollContainer.prop('offsetHeight'),
                scrollContainerPosition = $scrollContainer.prop('scrollTop'),
                currentRowPosition = $elm.parent().position().top,
                currentRowHeight = 60,
                drawerHeight = 0,
                drawerBottomPosition = 0,
                scrollToValue = 0;

            timeoutList.push($timeout(function () {
                drawerHeight = $elm.prop('offsetHeight');
                drawerBottomPosition = currentRowPosition + currentRowHeight + drawerHeight;

                drawerColumnsEmpty();

                if (drawerBottomPosition > scrollContainerHeight) {
                    scrollToValue = scrollContainerPosition - (scrollContainerHeight - drawerBottomPosition);

                    $scrollContainer.animate({
                        scrollTop: scrollToValue
                    }, 200);
                }
            }, timerDelay));
        }

        function drawerColumnsEmpty() {
            $elm.find('.drawerCol').each(function () {
                let $drawerColumn = $(this);
                if ($drawerColumn.children().length > 1) {
                    $drawerColumn.css('visibility', 'visible');
                } else {
                    $drawerColumn.hide();
                }
            });
        }

        $scope.$on(landingConstant.event.OPEN_TASK_DETAIL_DRAWER, function () {
            if ($scope.itemModel.selected) {
                loadAssignedToImage();
                loadAssignedByImage();
                loadResolvedByImage();
                $scope.itemModel.drawerOpen = true;
                scrollDrawerIntoView();
            }
        });

        $scope.$on(landingConstant.event.CLOSE_TASK_DETAIL_DRAWER, function () {
            if ($scope.itemModel.drawerOpen) {
                timeoutList.push($timeout(function () {
                    $scope.itemModel.drawerOpen = false;
                }, timerDelay));
            }
        });

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'E',
        replace: true,
        scope: {
            itemModel: '<?',
            colViewModel: '<?',
            isAgent: '<?'
        },
        link: linkFunction,
        templateUrl: '/landing/directives/taskDetailsDrawer/taskDetailsDrawerDirective.tpl.html'
    };
};

angular.module('umLanding')
    .directive('taskDetailsDrawerDirective', TaskDetailsDrawerDirective);
